document.js;
("use strict");
import { module } from "../app";

module.service("documentsSvc", [
  "$http",
  "$q",
  "authService",
  "Document",
  "dataRetrieverService",
  "signalrService",
  "magViewApi",
  function (
    $http,
    $q,
    authService,
    Document,
    dataRetrieverService,
    signalrService,
    magViewApi
  ) {
    let DefaultDate = "01-01-1900";

    let getDocumentUrl = async function (document) {
      try {
        const resp = await $http.post(
          `${authService.currentMagViewUrl()}/api/techpadDocuments/generateDocumentSecureKey`,
          {
            ssn: document.SSN || "",
            sdate: document.SDate || DefaultDate,
            letterType: document.LetterType || "",
            id: document.Id,
            documentSource: document.DocumentSource,
            releaseFile: document.ReleaseFile,
            fileType: document.FileType,
          }
        );
        const secureKey = resp.data;
        const url = `${authService.currentMagViewUrl()}/SecureUrl/${secureKey}/TechpadDocuments/ViewPdf`;

        console.log("DOC URL: ", url);
        return url;
      } catch (err) {
        throw err;
      }
    };

    let getDocumentPages = async function (document) {
      try {
        const resp = await $http.post(
          `${authService.currentMagViewUrl()}/api/techpadDocuments/getDocumentPages`,
          {
            ssn: document.SSN || "",
            sdate: document.SDate || DefaultDate,
            letterType: document.LetterType || "",
            id: document.Id,
            documentSource: document.DocumentSource,
            releaseFile: document.ReleaseFile,
            fileType: document.FileType,
          }
        );
        return resp.data.pages;
      } catch (err) {
        throw err;
      }
    };

    let printDocument = async function (document, printerName) {
      try {
        await $http.post(
          authService.currentMagViewUrl() +
            "/api/techpadDocuments/PrintDocument?documentSource=" +
            document.DocumentSource,
          {
            ssn: document.SSN || "",
            sdate: document.SDate || DefaultDate,
            letterType: document.LetterType || "",
            id: document.Id,
            releaseFile: document.ReleaseFile,
            printerName: printerName,
          }
        );
      } catch (err) {
        throw err;
      }
    };

    let getFormSettings = function (formName) {
      let formNameEncoded = encodeURIComponent(formName);
      return $http.get(
        authService.currentMagViewUrl() +
          "/api/surveyDocuments/signatureFormSettings?fileName=" +
          formNameEncoded
      );
    };

    let getSignatureForms = function () {
      return $http.get(
        authService.currentMagViewUrl() + "/api/surveyDocuments/signatureForms"
      );
    };

    let createDocument = async function (
      ssn,
      sdate,
      formName,
      config,
      docType,
      docDescription
    ) {
      let pdfReportParameters = {
        Ssn: ssn,
        SDate: sdate,
        PdfTemplateFileName: formName,
        Elements: config,
        DocType: docType,
        DocDescription: docDescription,
      };

      let url = `${authService.currentMagViewUrl()}/api/documents/CreatePdfFormDocument`;

      try {
        const resp = await $http.post(url, pdfReportParameters);
        return resp;
      } catch (error) {
        throw error;
      }
    };

    const generateTrfDocument = async function (ssn, sDate) {
      try {
        const resp = await $http.post(
          `${authService.currentMagViewUrl()}/api/techpadDocuments/GenerateTrfDocument`,
          {
            ssn: ssn,
            sdate: sDate,
          }
        );
        return resp.data;
      } catch (err) {
        throw err;
      }
    };

    const onTrfFormPrinted = async function (ssn, printer) {
      try {
        const resp = await $http.post(
          `${authService.currentMagViewUrl()}/api/techpadDocuments/setTrfPrintedDate`,
          {
            ssn: ssn,
            printerName: printer,
          }
        );
        return resp.data;
      } catch (err) {
        throw err;
      }
    };

    function registerOnDocumentsCreate(fun) {
      signalrService.worklist.on("documentsCreated", fun);

      return {
        unsubscribe: function () {
          signalrService.worklist.off("documentsCreated", fun);
        },
      };
    }

    function getEnabledPrinters() {
      return $http.post(
        authService.currentMagViewUrl() +
          "/api/techpadDocuments/getEnabledPrinters"
      );
    }

    function loadContactTypes() {
      const url = `${authService.currentMagViewUrl()}/api/techpadDocuments/loadContactTypes`;
      return $http.get(url);
    }

    async function createContact(model) {
      const url = `${authService.currentMagViewUrl()}${magViewApi}/contact`;
      try {
        return await $http.put(url, model);
      } catch (err) {
        throw err;
      }
    }

    async function updateContact(model) {
      const url = `${authService.currentMagViewUrl()}${magViewApi}/contact`;
      try {
        return await $http.post(url, model);
      } catch (err) {
        throw err;
      }
    }

    async function loadContact(ssn, id) {
      const url = `${authService.currentMagViewUrl()}${magViewApi}/contact/loadContact`;
      const model = { ssn, id };
      try {
        return await $http.post(url, model);
      } catch (err) {
        throw err;
      }
    }

    async function deleteContact(ssn, id) {
      const url = `${authService.currentMagViewUrl()}${magViewApi}/contact/deleteContact`;
      const model = { ssn, id };
      try {
        return await $http.post(url, model);
      } catch (err) {
        throw err;
      }
    }

    let service = {
      printDocument: printDocument,
      getDocumentUrl: getDocumentUrl,
      getDocumentPages: getDocumentPages,
      getAllBySsn: Document.getAllBySsn,
      getRadReportBySsnAndSDate: Document.getRadReportBySsnAndSDate,
      getFilmsComparedDocument: Document.getFilmsComparedDocument,
      registerOnDocumentsCreate: registerOnDocumentsCreate,
      getFormSettings: getFormSettings,
      createDocument: createDocument,
      getSignatureForms: getSignatureForms,
      getEnabledPrinters: getEnabledPrinters,
      loadContactTypes: loadContactTypes,
      createContact: createContact,
      updateContact: updateContact,
      loadContact: loadContact,
      deleteContact: deleteContact,
      generateTrfDocument: generateTrfDocument,
      onTrfFormPrinted: onTrfFormPrinted,
      saveImportDocuments: Document.saveImportDocuments,
      deleteDocument: Document.deleteDocument,
    };

    return service;
  },
]);



// WEBPACK FOOTER //
// ./src/scripts/services/documents.js